import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from "@mui/material";
import { useEffect, useState } from "react";
import { sistema } from "../../../../model/Sistema";
import { CheckCircle, DoneAll, ExpandMore as ExpandMoreIcon, PublishedWithChanges, RemoveDone, Search } from "@mui/icons-material";

const ConfirmacionReserva = ({open, onClose, onConfirm, reservas, costoTotal}) => {

  const unique = arr => {
    const seenIds = new Map();
    return arr.filter(obj => {
      if (seenIds.has(obj.id)) {
        return false; // Skip if ID is already seen
      }
      seenIds.set(obj.id, true); // Mark ID as seen
      return true; // Keep the object
    });
  }

  const datos = reservas[0];
  const espacioSeleccionado = datos?.espacio;
  const turnoSeleccionado = datos?.turno;
  const usuarioAsignado = datos?.usuarioAsignado;
  const esDiaDePrueba = datos?.esDiaDePrueba;
  const fechasSeleccionadas = Array.from(new Set(reservas?.map(item => item.fecha)));
  const [sectoresSeleccionados, setSectoresSeleccionados] = useState(unique(reservas?.map(item => item.mesa?.sector)));
  const puestosSeleccionados = Array.from(new Set(reservas?.map(item => item.puesto))).map(item => { return { ...item, sectorNombre: reservas.find(r => r.puesto.id == item.id && r.puesto.desk_id == item.desk_id)?.mesa?.sector?.nombre ?? null } });
  const mesasSeleccionadas = Array.from(new Set(reservas?.map(item => item.mesa)));

  useEffect(() => {
    const sectores = sectoresSeleccionados.map(sector => {return {...sector}});
    sectores.forEach(sector => {
      sector.mesas = mesasSeleccionadas.filter(mesa => mesa.sector.id === sector.id).map(mesa => {
        const puestos = puestosSeleccionados.filter(puesto => puesto.desk_id == mesa.id).sort((a,b) => a.id - b.id);
        return { ...mesa, puestosAReservar: puestos }
      });
    });
    setSectoresSeleccionados(sectores);
  }, []);

  useEffect(() => {
    sistema.actual.sectoresSeleccionados = sectoresSeleccionados;
  }, [sectoresSeleccionados]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirmar reserva</DialogTitle>
      <DialogContent dividers>
        <Typography variant="subtitle" gutterBottom>
          {'Reservarás a nombre de ' +  usuarioAsignado?.descripcion + ':'}
        </Typography>
        <Divider sx={{ my: 2 }} />
          <Accordion key={'puestos'} >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle" gutterBottom>
                {puestosSeleccionados.length + ' puesto' + (puestosSeleccionados.length > 1 ? 's' : '')}
              </Typography>
              {/* <Typography variant="subtitle1">Detalle de puestos</Typography> */}
            </AccordionSummary>
            <AccordionDetails>
            <List dense>
              {/* {puestosSeleccionados.sort((a, b) => a.sectorNombre.localeCompare(b.sectorNombre) || a.mesaNombre.localeCompare(b.mesaNombre) || a.id - b.id).map((puesto, index) => (
                <ListItem key={`${puesto.desk_id}-${puesto.id}`}>
                  <ListItemText
                    primary={`Sector: ${puesto.sectorNombre ?? '-'} | Mesa: ${puesto.mesaNombre ?? '-'} | Puesto #${puesto.id}`}
                  />
                </ListItem>
              ))} */}
              {sectoresSeleccionados.sort((a, b) => a.nombre.localeCompare(b.nombre)).map((sector, index) => (
                <ListItem key={sector.id}>
                  <ListItemText primary={'Sector: ' + sector.nombre + ' (' + sector?.mesas?.reduce((val,mesa) => val += mesa.puestosAReservar.length, 0) + ' puestos)'} secondary={
                    <List dense disablePadding sx={{display: 'flex', flexDirection: 'row'}}>
                      {sector.mesas?.map(mesa => (
                        <ListItem key={mesa.id} alignItems="flex-start">
                          <ListItemText primary={'Mesa: ' + mesa.nombre} secondary={mesa.puestosAReservar.length + ' puestos ( ' + mesa.puestosAReservar.reduce((val, puesto) => val += puesto.id + ' ', '') + ')'} />
                        </ListItem>
                      ))}
                    </List>
                  } />
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>

        <Divider sx={{ my: 2 }} />

        <Accordion key={'fechas'} >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle" gutterBottom>
              {fechasSeleccionadas.length + ' fecha' + (fechasSeleccionadas.length > 1 ? 's' : '')}
            </Typography>
            {/* <Typography variant="subtitle1">Detalle de puestos</Typography> */}
          </AccordionSummary>
          <AccordionDetails>
            <List dense>
              {fechasSeleccionadas.map((fecha, index) => (
                <ListItem key={index}>
                  <ListItemText
                    primary={fecha.format('L ddd')} // si usas moment()
                  />
                </ListItem>
              ))}
              </List>
          </AccordionDetails>
        </Accordion>

        <Divider sx={{ my: 2 }} />


        <Typography variant="subtitle1" gutterBottom>
          Turno: {turnoSeleccionado.nombre}
        </Typography>

        <Typography variant="subtitle1" gutterBottom>
          Sede: {espacioSeleccionado.nombre}
        </Typography>

        <Typography variant="subtitle1" gutterBottom>
          {'Costo: ' + costoTotal}
        </Typography>

        <Typography variant="subtitle1" gutterBottom>
          {!!esDiaDePrueba
            ? 'Día de prueba para: ' + usuarioAsignado.emailDeContacto
            : (usuarioAsignado.tipo == 'EMPRESA'
              ? 'Usuario sin asignar'
              : 'Usuario asignado: ' + usuarioAsignado?.descripcion ?? "-"
            )
          }
        </Typography>

      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          Confirmar reserva
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmacionReserva;
